<template>
    <div>
        <!-- section start -->
        <section>
            <div class="inner row3">
                <article>
                    <div class="aRow3 alignC newAgingCon">
                        <h1>AgeTech Platform 등장배경 : SSK 사업단</h1>
                          <figure>
                            <img style="width: 60rem; height: auto" src="../../assets/images/cmmnMain/ageTech_Platform_logo.png" alt="logo">
                          </figure>
                        <div class="flex platformInfo">
                            <div class="wd50 platformInfoTxt">
                                <h3>
                                    시니어산업플랫폼
                                </h3>
                                <p>
                                    우리나라는 시니어산업에 대한 수요가 늘어나고
                                    있습니다. 시니어를 위한 제품과 서비스의 수요 대응을
                                    위해 시니어산업의 중요성이 강조되고 있습니다.
                                </p>
                            </div>
                            <div class="wd50 platformInfoTxt">
                                <h3>
                                  AgeTech Platform
                                </h3>
                                <p>
                                    경희대학교 동서의학대학원에서는 시니어산업 성장과
                                    패러다임 전환을 위해 시니어 산업체가 제품과 서비스를
                                    소개하고 시니어 소비자는 필요한 정보들을 제공받을 수 있도록 플랫폼을 구축하였습니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </section>

        <section>
            <div class="inner row8">
                <article>
                    <div class="aRow3 alignC serviceVisionCon">
                        <h1 class="mainTitle">서비스 비전</h1>
                        <figure class="mobileNotBlock">
                            <img src="../../assets/images/cmmnMain/serviceVision.png" alt="서비스 비전">
                        </figure>
                        <figure class="mobileBlock">
                            <img src="../../assets/images/mobileImg/서비스비전.png" alt="서비스 비전 모바일">
                        </figure>
                    </div>
                </article>
            </div>
        </section>

        <section>
            <div class="inner row8">
                <article>
                    <div class="aRow3 alignC serviceVisionCon mobileVer">
                        <h1 class="mainTitle">과제 단계별 목표</h1>
                        <figure class="mobileNotBlock">
                            <img src="../../assets/images/cmmnMain/stepTarget.png" alt="단계 목표">
                        </figure>

                        <figure class="mobileBlock imgWidth100">
                            <img src="../../assets/images/mobileImg/단계목표.png" alt="단계 목표 모바일">
                        </figure>
                    </div>
                </article>
            </div>
        </section>

        <section>
            <div class="inner row8">
                <h1 class="mainTitle">디지털 격차</h1>
                <article class="aInner">
                    <div class="mobileTMg30 mbBtAdd">
                        <p class="alignC">
                            새로운 기술의 등장으로 시니어는 기술 활용의 어려움 등 디지털 격차를 겪고 있으며, <br class="mobileNotBr">
                            이는 삶의 질 감소, 사회적 소외 및 우울의 증가 등 시니어에게 부정적인 영향을 미치고 있습니다. <br class="mobileNotBr">
                            경희대학교에서는 SSK사업을 통해 이러한 격차를 줄이기 위해 연구하고 있습니다. 
                        </p>
                    </div>
                </article>
                <div class="serviceNeeds">
                    <div class="flex newsBox mobileReset">
                        <div class="newsItem">
                            <figure>
                                <img src="../../assets/images/cmmnMain/헤럴드경제.png" alt="헤럴드 신문 이미지">
                            </figure>
                        </div>
                        <div class="newsItem">
                            <figure>
                                <img src="../../assets/images/cmmnMain/연합뉴스.png" alt="연합뉴스 신문 이미지">
                            </figure>
                        </div>
                        <div class="newsItem">
                            <figure>
                                <img src="../../assets/images/cmmnMain/아주경제.png" alt="아주경제 신문 이미지">
                            </figure>
                        </div>
                    </div>
                    <div class="movileServieVision mobileBlock">
                        <VueSlickCarousel v-bind="settings">
                            <div class="movileServieVisionImg">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/헤럴드경제.png" alt="헤럴드 신문 이미지">
                                </figure>
                            </div>
                            <div class="movileServieVisionImg">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/연합뉴스.png" alt="연합뉴스 신문 이미지">
                                </figure>
                            </div>
                            <div class="movileServieVisionImg">
                                <figure>
                                    <img src="../../assets/images/cmmnMain/아주경제.png" alt="아주경제 신문 이미지">
                                </figure>
                            </div>
                        </VueSlickCarousel>
                    </div>
                </div>
            </div>
        </section>
        
        <div class="mobileTop mobileBlock">
            <button>
                <img src="../../assets/images/Btn/맨위로가기버튼.png" alt="">
            </button>
        </div>
    </div>   
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'GlobalTrend',
    components: {
        VueSlickCarousel 
    },
    data() {
        return {
            settings: {
                dots:true,
                arrows:false,
                fade:true,
                speed:1500,
                infinite:true,
                autoplay:true,
                autoplaySpeed:5000,
                pauseOnDotsHover:true,
                pauseOnHover:true,
                "responsive": [
                    {
                    "breakpoint": 560,
                    "settings": {
                        "slidesToShow": 1,
                        "slidesToScroll": 1,
                    }
                    },
                ]
            }
        }
    },
}

</script>

<style scoped>
    .topMenu ul li.active:after {
        content: '';
        position: absolute;
        width: 120%;
        height: 7px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background: #26336A;
    }
    a {
        color: #272727;
    }
    a.mainBgBtn {
        color: #FFF;
    }
    h3 {
        margin: 0 0 16px 0;
    }
    .mobileCarousel .slick-slide img {
        margin: 30px auto;
    }
    @media screen and (max-width: 560px) {
        .matchPlaform h3 {
            margin: 0;
        }
        .matchPlaform div p {
            margin: 0 0 20px 0;
        }
    }
</style>

